<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.user.logForm') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="submitLogin">
                  <v-text-field
                    label="Email"
                    name="email"
                    type="email"
                    v-model="email"
                    outlined
                    prepend-icon="$vuetify.icons.user"
                  ></v-text-field>

                  <v-text-field
                    hide-details
                    id="password"
                    :label="$vuetify.lang.t('$vuetify.user.password')"
                    name="password"
                    prepend-icon="$vuetify.icons.lock"
                    type="password"
                    v-model="password"
                    outlined
                  ></v-text-field>
                </v-form>
                <div class="pl-8">
                  <router-link :to="{ name: 'reset-password' }">{{
                    $vuetify.lang.t('$vuetify.user.forgottenPassword')
                  }}</router-link>
                </div>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1" />

                <v-btn color="primary" @click="submitLogin">{{ $vuetify.lang.t('$vuetify.user.login') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: { source: String },

  data() {
    return {
      email: null,
      password: null,
    };
  },

  methods: {
    ...mapActions('auth', {
      attemptLogin: 'attemptLogin',
      fetchMe: 'fetchMe',
    }),

    keyDown(event) {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        this.submitLogin();
      }
    },

    submitLogin() {
      const { email, password } = this;
      this.attemptLogin({ email, password })
        .then(() => {
          window.removeEventListener('keydown', this.keyDown);

          this.fetchMe();
          this.$router.push({ name: 'search' });
        })
        .catch(err => {
          console.log(err);
        });
    },
  },

  created() {
    window.addEventListener('keydown', this.keyDown);
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.keyDown);
  },
};
</script>
